import http from 'axios'
const protocol = window.location.protocol
/**
 * v-uploader plugin global config
 */
const uploaderConfig = (lang) => {
  return {
    language: lang,
    /**
     * file uploader server url
     *
     * return result
     * {
     *      success: true,//boolean, required
     *      error: 'error message to display',//error message, required when upload fail
     *
     *      fileId: '123'//your custom file info
     *      ...
     * }
     *
     * for example
     * success:
     * {success: true, fileId: '123', fileName: '2018-04-26-1023.jpg'}
     * fail:
     * {success: false, error: 'file upload fail, out of space.'}
     *
     * for detail, visit fine-uploader site
     * https://docs.fineuploader.com/branch/master/endpoint_handlers/traditional.html
     */
    uploadFileUrl: protocol + '//www.mocky.io/v2/5ae5838e2e00005d003824ab', // 'http://xxx/upload/publicFileUpload',
    /**
     * file delete server url
     * the server just response 200 status, no need to return data
     *
     * for detail, visit fine-uploader site
     * https://docs.fineuploader.com/branch/master/endpoint_handlers/traditional.html
     */
    deleteFileUrl: protocol + '//www.mocky.io/v2/5ae5838e2e00005d003824ab', // http://xxx/upload/deleteUploadFile',
    /**
     * set the way to show upload message(upload fail message)
     *
     * @param vue - the Vue instance
     * @param message - upload file message
     */
    showMessage: (vue, message) => {
      // using v-dialogs to show message
      vue.$vDialog.alert(message, null, {
        messageType: 'error',
        language: 'en'
      })
    }
  }
}

const dataLoadConfig = (vue, data, params) => {
  return new Promise((resolve, reject) => {
    // vue.$http(data, params).then(resp=>resolve(resp)).then(resp=>reject(resp));
    let url = data
    if (!url.startsWith('http')) {
      url = protocol + '//' + url
    }
    http.post(url, params)
      .then(resp => resolve(resp))
      .catch(error => reject(error))
  })
}

export { dataLoadConfig }
export { uploaderConfig }
